import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as GlobeIcon } from '../assets/icons/globe.svg';
import { ReactComponent as CheckIcon } from '../assets/icons/check.svg';
import './LanguageSelector.css';

// English primero (idioma principal, ver core/03-decisiones.md 2026-09-11), luego
// alfabetico por nombre nativo, con los de alfabeto latino antes que el resto.
const languages = [
  { code: 'en', name: 'English' },
  { code: 'id', name: 'Bahasa Indonesia' },
  { code: 'de', name: 'Deutsch' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'it', name: 'Italiano' },
  { code: 'nl', name: 'Nederlands' },
  { code: 'pl', name: 'Polski' },
  { code: 'pt', name: 'Português' },
  { code: 'vi', name: 'Tiếng Việt' },
  { code: 'tr', name: 'Türkçe' },
  { code: 'ar', name: 'العربية' },
  { code: 'bn', name: 'বাংলা' },
  { code: 'hi', name: 'हिन्दी' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'ru', name: 'Русский' },
  { code: 'th', name: 'ไทย' },
  { code: 'ur', name: 'اردو' },
  { code: 'zh', name: '中文' },
];

function LanguageSelector() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  // resolvedLanguage es el idioma base que i18next esta usando de verdad (es-ES -> es,
  // pt-BR -> pt, zh-TW -> zh); i18n.language puede traer la variante regional detectada.
  const activeCode = i18n.resolvedLanguage || i18n.language;
  const currentLanguage = languages.find(lang => lang.code === activeCode) || languages[0];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="language-selector">
      <button className="language-btn" onClick={() => setIsOpen(!isOpen)} aria-label={currentLanguage.name}>
        <GlobeIcon width={16} height={16} aria-hidden="true" />
        <span className="lang-code">{currentLanguage.code.toUpperCase()}</span>
      </button>

      {isOpen && (
        <>
          <div className="language-backdrop" onClick={() => setIsOpen(false)} />
          <div className="language-dropdown">
            {languages.map(lang => (
              <button
                key={lang.code}
                className={`language-option ${activeCode === lang.code ? 'active' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                <span className="lang-name">{lang.name}</span>
                {activeCode === lang.code && <span className="check"><CheckIcon width={14} height={14} aria-hidden="true" /></span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default LanguageSelector;
